import { render } from "./LbrxStatisticsTable.vue?vue&type=template&id=32a105d0&scoped=true"
import script from "./LbrxStatisticsTable.vue?vue&type=script&lang=js"
export * from "./LbrxStatisticsTable.vue?vue&type=script&lang=js"

import "./LbrxStatisticsTable.vue?vue&type=style&index=0&id=32a105d0&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a105d0"]])

export default __exports__